export const FETCH_TOURNAMENT_SUSPENSIONS_REQUEST = 'tournament/suspensions/fetch/request';
export const FETCH_TOURNAMENT_SUSPENSIONS_SUCCESS = 'tournament/suspensions/fetch/success';
export const FETCH_TOURNAMENT_SUSPENSIONS_FAIL = 'tournament/suspensions/fetch/fail';
